import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'

import {useUser} from '../users/hooks'
import {useSessions} from '../FinancialsDashboard/hooks'
import {useDebounceCallback} from '@react-hook/debounce'

import useBranding from '../../hooks/useBranding'

import {useHistory} from 'react-router-dom'

import {getProspectiveClients} from '../Growth/slice'

import {
	getRecentNotes,
	selectAllNotes,
	saveNote,
	deleteNote,
	updateNote,
	initNotes
} from '../../state/clientNotesSlice'

import { getChatRooms } from '../MessageCenter/messageCenterSlice';

import {useActiveSubscriptions} from '../FinancialsDashboard/hooks'

import {
	setClientKey,
	selectClientsById,
	addTagToClient,
	removeTagFromClient,
	getAllClients,
	updateProfileData,
	deleteProgramAssignment,
	selectTrainerParam,
	createClient,
	updateClientAccountStatus,
	downgradeClientToProspect,
	getClient,
	selectUsersIds,
	getClubReadyIdBarcode,
	createClubReady,
	deleteClient
} from '../users/usersSlice'

import {
	useUpdateClientProfileData,
	useRemoveClient
} from '../users/hooks'

import {
	useClientCustomForms
} from '../customForms/hooks'

import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import useS3DirectUpload from '../../hooks/useS3DirectUpload'

import { 
	addFormToClient,
	removeFormFromClient,
	updateFormComplete 
} from "../../state/customFormsSlice"

import { useTags } from '../../hooks/useTags'

import {
	insertTag,
	updateTagColor
} from '../../state/accountTagsSlice'

import {
	envAwareFormSubmit,
	envAwarePost,
	dateToAPIStandard,
	ellipsis,
	capitalize
} from '../../util/util'

import {
	dateToYMD
} from '../../util/datetime'

import useCurrentUser from '../../hooks/useCurrentUser'

import {setShowUpdateModal} from '../FinancialsDashboard/Billing/slice'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as faIcons  from '@fortawesome/free-solid-svg-icons'

import Select from 'react-select'

import {Link} from 'react-router-dom'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import ProgressBar from 'react-bootstrap/ProgressBar'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import InputGroup from 'react-bootstrap/InputGroup'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Popover from 'react-bootstrap/Popover'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Badge from 'react-bootstrap/Badge'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

import useStripeAccount from '../../hooks/useStripeAccount'

import CreatableSelect from 'react-select/creatable'

import { CirclePicker } from 'react-color'

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import ClientSessionsRow from '../FinancialsDashboard/Sessions/ClientSessionsRow'
import {setClientSessionsModal} from '../FinancialsDashboard/Sessions/sessionsSlice'
import AddSessionModal from '../FinancialsDashboard/Sessions/AddSessionModal'
import DeleteProgramModal from '../programs/DeleteModal/DeleteModal'

import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js'

import LocaleDate from '../LocaleDate/LocaleDate'

import css from './ClientProfile.module.css'

import {ActiveSubscription} from '../FinancialsDashboard/Subscriptions/ActiveSubscriptions'

const Group = ({name,children,icon})=>{
	const branding = useBranding()
	return (
		<div className={css.Group}>
			<div className={css.GroupName} style={{
				background: (
					Boolean(branding)
						? branding.backgroundColor
						:'#4146cc'
				),
				color:(
					Boolean(branding)
						? branding.textColor 
						: '#fff'
					)
			}}>
				<FontAwesomeIcon icon={faIcons[icon]}/> {name}
			</div>
			{children}
		</div>
	)
}

const ResendWelcomeEmailButton = ({ client_id }) => {
	const [status, setStatus] = useState('idle')
	const isMAXUser = useSelector(state => Boolean(state.users.current_user.isMAXUser))
	const handleSend = () => {
		if (!window.confirm(`This will reset this ${isMAXUser ? 'member' : 'client'}'s password and send them a new one in the email. Continue?`)) return
		setStatus('pending')
		envAwarePost('api/users/api/', {
			action: 'resendWelcomeEmail',
			client_id
		}).then(res => {
			setStatus('idle')
			if (res.success !== '1') {
				alert(res.message)
			} else {
				alert('Email sent successfully.')
			}
		})
	}
	return (
		<Button
			disabled={status === 'pending'}
			variant="outline-primary"
			onClick={handleSend}
			className="mt-2"
			size="sm"
			block
		>
			<FontAwesomeIcon icon={faIcons.faRotateRight} className="mr-1"/>
			<span>Resend Welcome Email</span> {status === 'pending' && <Spinner animation="border" size="sm" />}
		</Button>
	)
}

const SetupAccount = ({clientId})=>{
	const client = useUser(clientId)
	const update = useUpdateClientProfileData()

	const [setupAccount,setSetupAccount] = useState(false)

	const [email,setEmail] = useState('')
	const [password,setPassword] = useState('')

	const [isSaving,setIsSaving] = useState(false)
	const handleSave = ()=>{
		setIsSaving(true)
		update(clientId,{
			password,
			user_email:email,
			user_id:email,
			setup_account:1
		}).then(()=>{
			setIsSaving(false)
		})
	}

	return (
		<div>
			{!Boolean(setupAccount)&&
				<Button 
					onClick={setSetupAccount.bind(null,true)}
					variant="outline-primary"
					className="my-1"
					size="sm"
					block
				>
					Enable Client to Login
				</Button>
			}
			{Boolean(setupAccount)&&
				<div>
					<div>
						<strong>Email</strong>
						
						<InputGroup size="sm">
							<InputGroup.Prepend>
								<InputGroup.Text>
									<FontAwesomeIcon icon={faIcons.faAt}/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control 
								size="sm" 
								defaultValue={client?.user_email} 
								onChange={(e)=>{
									setEmail(e.target.value)
								}}
							/>
						</InputGroup>
					</div>
					<div>
						<strong>New Password</strong>
						<InputGroup size="sm">
							<InputGroup.Prepend>
								<InputGroup.Text>
									<FontAwesomeIcon icon={faIcons.faLock}/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control 
								size="sm" 
								value={password}
								type="password"
								onChange={(e)=>{
									setPassword(e.target.value)
								}}
							/>
						</InputGroup>
					</div>
					<div className="d-flex justify-content-between mt-2">
						<Button 
							onClick={setSetupAccount.bind(null,false)}
							variant="outline-danger" 
							size="sm"
						>
							Cancel
						</Button>
						<Button 
							onClick={handleSave}
							disabled={isSaving}
							variant="outline-success" 
							size="sm"
						>
							Save {isSaving&&<Spinner animation="border" size="sm"/>}
						</Button>
					</div>
				</div>
			}
		</div>
	)
}

const Tag = ({ tag, clientId }) => {

	const dispatch = useDispatch()
	const { color } = tag
	const colorChangeHandler = (colorObj) => {
		const { hex } = colorObj
		dispatch(updateTagColor({
			tag_id: tag.id,
			color: hex
		}))
	}
	return (
		<span style={{ position: 'relative' }} className="m-1">
			<span className="rounded border d-flex" style={{ overflow: 'hidden' }}>
				<OverlayTrigger rootClose trigger="click" placement="top" overlay={
					<Popover>
						<Popover.Content>
							<CirclePicker onChangeComplete={colorChangeHandler} />
						</Popover.Content>
					</Popover>
				}>
					<button style={{
						width: '24px',
						background: color,
						border: 'none'
					}} />
				</OverlayTrigger>
				<small className="d-block py-1 px-3" style={{ textWrap: 'nowrap' }}>
					{tag.name}
				</small>
			</span>
			<i style={{
				position: 'absolute',
				top: '-4px',
				right: '-4px',
				width: '12px',
				height: '12px'
			}}
				onClick={() => {
					dispatch(removeTagFromClient({
						tag_id: tag.id,
						client_id: clientId
					}))
				}}
				className="fa fa-times text-danger"> </i>

		</span>
	)
}

const Tags = ({ clientId }) => {
	const dispatch = useDispatch()
	const client = useSelector(state => selectClientsById(state, clientId))
	//pull tags from the accountTags slice
	const tags = useSelector(state => {
		if (!client) return []
		return client.tags.map(tag => state.accountTags.adapter.entities[tag.id]).filter(tag => Boolean(tag))

	})

	let colors = ["f44336", "e91e63", "9c27b0", "673ab7", "3f51b5", "2196f3",
		"03a9f4", "00bcd4", "009688", "4caf50", "8bc34a", "cddc39", "ffeb3b",
		"ffc107", "ff9800", "ff5722", "795548", "607d8b"]

	function randomColor(colors) {
		return colors[Math.floor(Math.random() * colors.length)];
	}

	const allTags = useTags('all')
	const [error, setError] = useState(false)
	const [newTag, setNewTag] = useState('')
	const [showProgramsModal, setShowProgramsModal] = useState(false)

	const addTagHandler = () => {
		if (Boolean(newTag)) {
			setError(true)
			setNewTag('')
			let tagColor = randomColor(colors)
			envAwarePost('api/users/api/', {
				action: 'addTagToClient',
				tag_name: newTag.value,
				color: tagColor,
				client_id: clientId
			}).then(res => {
				let tagPayload = res.data;
				dispatch(insertTag(tagPayload))
				dispatch(addTagToClient({
					tag: tagPayload,
					clientId,
				}))
			})
		}
	}
	if (!client) return null
	return (
		<div>
			<small>
				<FontAwesomeIcon icon={faIcons.faCircleInfo} className="mr-1"/>
				Tags let you organize clients into groups and are integrated throughout the app to simplify working with large groups of clients. 
			</small>
			<div>

				<div className="mb-3 d-flex">
					<CreatableSelect
						isClearable
						className="w-100 mr-1"
						default={newTag}
						onChange={tag => setNewTag(tag)}
						options={allTags.map(
							tag => ({
								value: tag.name,
								label: tag.name
							})
						)}
					/>
					<Button
						disabled={!Boolean(newTag)}
						onClick={addTagHandler}
						variant={Boolean(newTag) ? "outline-success" : "outline-secondary"}
					>
						<i className="fa fa-plus" />
					</Button>
				</div>
			</div>
			<div className="d-flex flex-wrap">
				{tags.map(tag => (
					<Tag clientId={clientId} tag={tag} />
				))}
			</div>
		</div>
	)
}

const GymOptions = ({ clientId }) => {
	const user = useUser(clientId)
	const trainerId = user?.user_trainer_id
	const [trainers, setTrainers] = useState([])
	const client = useSelector(state => selectClientsById(state, clientId))
	const isMAXUser = useSelector(state => Boolean(state.users.current_user.isMAXUser))

	const update = useUpdateClientProfileData()

	const gymId = useSelector(state => state.users?.current_user?.gym_id)
	useEffect(() => {
		envAwarePost('api/users/api/', {
			action: 'getAllTrainers'
		}).then(res => {
			setTrainers(res.data)
		})
	}, [])
	return (
		<div>
			<div>
				<Alert variant="info" className="text-dark">
					<FontAwesomeIcon icon={faIcons.faCircleInfo} className="mr-1"/>
					Assign this {isMAXUser ? 'member' : 'client'} to a specific trainer, mark them as shared or unassign them. <strong>Assigned</strong> clients can only be accessed by the gym and their assigned trainer. <strong>Shared</strong> clients can be accessed by the gym and all trainers. <strong>Unassigned</strong> clients can only be accessed by the gym. Not sure? send questions to <a href="mailto:support@fitsw.com">Support</a>
				</Alert>
			</div>
			<strong>Current Trainer</strong>
			<InputGroup>
				<InputGroup.Prepend>
					<InputGroup.Text>
						<FontAwesomeIcon icon={faIcons.faPersonRays}/>
					</InputGroup.Text>
				</InputGroup.Prepend>
				<Form.Control
					onChange={e => update(clientId,{user_trainer_id:e.target.value})}
					value={trainerId}
					as="select"
					custom
				>
					<option value={0}>None</option>
					<option value={gymId}>Shared</option>
					{trainers.map(trainer => (
						<option value={trainer.user_id_number}>
							{trainer.user_name}
						</option>
					))}
				</Form.Control>
			</InputGroup>
		</div>
	)
}

const ClientInfo = ({clientId})=>{
	const dispatch = useDispatch()
	const client = useUser(clientId)
	const history = useHistory()

	const update = useUpdateClientProfileData()
	const remove = useRemoveClient()

	const isMAXUser = useSelector(state => Boolean(state.users?.current_user?.isMAXUser))

	const {processUpload} = useS3DirectUpload()

	const clientHasAccount = client?.user_email!=='No Email'

	const handleChangeProfilePic = async e =>{
		const pic = e.target.files[0]
		if (!pic) return 
		const s3Res = await processUpload(pic)
		update(clientId,{profile_pic:s3Res.payload.url})
	}

	const [downgrading,setDowngrading] = useState(false)
	const handleDowngradeToProspect = ()=>{
		if(!window.confirm('Are you sure you want to downgrade this client?')) return 
		setDowngrading(true)
		dispatch(downgradeClientToProspect(clientId)).then(()=>(
			dispatch(getProspectiveClients()).then(()=>{
				setDowngrading(false)
				history.push('/growth')
			})
		))
	}

	const debouncedUpdate = useDebounceCallback(update,500)

	const [changingPassword,setChangingPassword] = useState(false)
	const [newPassword,setNewPassword] = useState('')

	const partOfGym = Boolean(client?.gym_id)

	const gymComponent = (
		partOfGym 
		? {
			name:'Gym Options',
			icon:'faBuildingUser',
			component:<GymOptions clientId={clientId}/>
		}
		: null
	)

	const groups = [
		{
			name:isMAXUser?'Member':'Client',
			icon:'faImage',
			component:(
				<div className="mr-3">
					<div>
						<img 
							width={160} height={160} 
							style={{ objectFit: 'cover' }} 
							className="rounded-circle d-block m-auto" 
							src={
								client?.profile_pic 
								? client?.profile_pic 
								: "https://cdn.fitsw.com/assets/img/defaultProfile.png"
							}
						/>
						<Form.File
							onChange={handleChangeProfilePic}
							id="client-profile-pic" 
							label="Change Image"
							className="mt-2"
							custom
						/>
					</div>
					<div className="d-flex justify-content-around mt-1">
						{client?.date_create ?
							(
								<small>
									Signed up: {new Date(client?.date_create?.split(' ').join('T')).toLocaleDateString()}
								</small>
							) : null
						}
						{(new Date(client?.last_login).toLocaleDateString() !== "Invalid Date") ? (
							<small>
								Last Login: {
									new Date(client?.last_login?.split(' ').join('T')).toLocaleDateString()

								}
							</small>
						) : null}
					</div>
				</div>
			)
		},
		{
			name:'Account',
			icon:'faUserGear',
			component:(
				<div>
					<div className="d-flex">
						<div style={{flex:'1 1 auto'}}>
							<div>
								<strong>Display Name</strong>
								<InputGroup size="sm">
									<InputGroup.Prepend>
										<InputGroup.Text>
											<FontAwesomeIcon icon={faIcons.faUser}/>
										</InputGroup.Text>
									</InputGroup.Prepend>
									<Form.Control 
										size="sm" 
										defaultValue={client?.user_name} 
										onChange={(e)=>{
											debouncedUpdate(
												clientId,
												{user_name:e.target.value}
											)
										}}
									/>
								</InputGroup>
							</div>
							{clientHasAccount&&
								<div>
									<strong>Email</strong>
									
									<InputGroup size="sm">
										<InputGroup.Prepend>
											<InputGroup.Text>
												<FontAwesomeIcon icon={faIcons.faAt}/>
											</InputGroup.Text>
										</InputGroup.Prepend>
										<Form.Control 
											size="sm" 
											defaultValue={client?.user_email} 
											onChange={(e)=>{
												debouncedUpdate(
													clientId,
													{user_email:e.target.value,user_id:e.target.value}
												)
											}}
										/>
										<InputGroup.Append>
											<OverlayTrigger overlay={
												<Tooltip>Send Email to client</Tooltip>
											}>
												<Button 
													variant="outline-success"
													href={`mailto:${client?.user_email}`}
												>
													<FontAwesomeIcon 
														className="mr-1" 
														icon={faIcons.faPaperPlane}
													/>
												</Button>
											</OverlayTrigger>
										</InputGroup.Append>
									</InputGroup>
								</div>
							}
							{!clientHasAccount&&
								<SetupAccount clientId={clientId}/>
							}
							{clientHasAccount&&
								<div className="mt-2">
									{!changingPassword&&
										<Button 
											onClick={setChangingPassword.bind(null,true)}
											variant="outline-dark"
											size="sm"
											block
										>
											<FontAwesomeIcon 
												icon={faIcons.faLock} 
												className="mr-1"
											/>
											Change Password
										</Button>
									}
									{changingPassword&&
										<div>
											<strong>New Password</strong>
											<InputGroup size="sm">
												<InputGroup.Prepend>
													<OverlayTrigger overlay={
														<Tooltip>Cancel password update</Tooltip>
													}>
														<Button 
															onClick={setChangingPassword.bind(null,false)}
															variant="outline-danger"
														>
															<FontAwesomeIcon icon={faIcons.faTimes}/>
														</Button>
													</OverlayTrigger>
												</InputGroup.Prepend>
												<Form.Control 
													size="sm" 
													value={newPassword}
													onChange={(e)=>{
														setNewPassword(e.target.value)
													}}
												/>
												<InputGroup.Append>
													<OverlayTrigger overlay={
														<Tooltip>Save new password</Tooltip>
													}>
														<Button 
															onClick={e=>{
																update(clientId,{password:newPassword})
																setNewPassword('')
																setChangingPassword(false)
															}}
															variant="outline-success"
														>
															<FontAwesomeIcon icon={faIcons.faSave}/>
														</Button>
													</OverlayTrigger>
												</InputGroup.Append>
											</InputGroup>
										</div>
									}
								</div>
							}
						</div>
					</div>
					{clientHasAccount&&
						<ResendWelcomeEmailButton client_id={clientId} />
					}
				</div>
			)//end account component
		},
		{
			name:'Bio',
			icon:'faAddressCard',
			component:(
				<div>
					<div>
						<strong>Phone</strong>
						<InputGroup size="sm">
							<InputGroup.Prepend>
								<InputGroup.Text>
									<FontAwesomeIcon icon={faIcons.faPhone}/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control 
								size="sm" 
								defaultValue={client?.phone} 
								onChange={(e)=>{
									debouncedUpdate(
										clientId,
										{phone:e.target.value}
									)
								}}
							/>
						</InputGroup>
					</div>
					<div>
						<strong>Date of Birth (optional)</strong>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text>
									<FontAwesomeIcon icon={faIcons.faCalendarDay}/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<DatePicker
								onChange={(newDate)=>{
									update(
										clientId,
										{birthdate:dateToYMD(newDate)}
									)
								}}
								selected={
									Boolean(client)&&Boolean(client.birthdate)&&client.birthdate!=='0000-00-00'
									? new Date(`${client?.birthdate}T00:00:00`)
									: new Date()
								}
								customInput={
									<Form.Control size="sm"/>
								}
							/>
							
						</InputGroup>
					</div>
					<div>
						<strong>Sex (optional)</strong>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text>
									<FontAwesomeIcon icon={faIcons.faPersonHalfDress}/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control 
								as="select" 
								defaultValue={client?.sex_id}
								onChange={e=>{
									update(clientId,{sex_id:e.target.value})
								}}
							>
								<option value={1}>Not Selected</option>
								<option value={2}>Male</option>
								<option value={3}>Female</option>
								<option value={4}>Other</option>
							</Form.Control>
						</InputGroup>
					</div>
					<div>
						<strong>Height (optional)</strong>
						<InputGroup size="sm">
							<InputGroup.Prepend>
								<InputGroup.Text>
									<FontAwesomeIcon icon={faIcons.faRulerVertical}/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control 
								size="sm"
								defaultValue={client?.height}
								onChange={e=>{
									debouncedUpdate(clientId,{height:e.target.value})
								}}
							/>
							<Form.Control 
								as="select" 
								defaultValue={client?.height_units}
								onChange={e=>{
									debouncedUpdate(clientId,{height_units:e.target.value})
								}}
							>
								<option value={0}>in</option>
								<option value={1}>cm</option>
							</Form.Control>
						</InputGroup>
					</div>
					<div>
						<strong>Weight (optional)</strong>
						<InputGroup size="sm">
							<InputGroup.Prepend>
								<InputGroup.Text>
									<FontAwesomeIcon icon={faIcons.faWeightScale}/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control 
								defaultValue={client?.weight}
								onChange={e=>{
									debouncedUpdate(clientId,{weight:e.target.value})
								}}
								size="sm"
							/>
							<Form.Control 
								as="select" 
								defaultValue={client?.weight_units}
								onChange={e=>{
									debouncedUpdate(clientId,{weight_units:e.target.value})
								}}
							>
								<option value={0}>lbs</option>
								<option value={1}>kg</option>
							</Form.Control>
						</InputGroup>
					</div>
				</div>
			)
		},
		{
			name:'General',
			icon:'faFileLines',
			component:(
				<div>
					<strong>
						<FontAwesomeIcon icon={faIcons.faBullseye} /> Goals
					</strong>
					<Form.Control 
						defaultValue={client?.goals}
						onChange={e=>{
							debouncedUpdate(clientId,{goals:e.target.value})
						}}
						as="textarea"
					/>
					<strong>
						<FontAwesomeIcon icon={faIcons.faThumbsUp} /> Likes
					</strong>
					<Form.Control 
						as="textarea"
						defaultValue={client?.likes}
						onChange={e=>{
							debouncedUpdate(clientId,{likes:e.target.value})
						}}
					/>
					<strong>
						<FontAwesomeIcon icon={faIcons.faThumbsDown} /> Dislikes
					</strong>
					<Form.Control 
						as="textarea"
						defaultValue={client?.dislikes}
						onChange={e=>{
							debouncedUpdate(clientId,{dislikes:e.target.value})
						}}
					/>
					<strong>
						<FontAwesomeIcon icon={faIcons.faUserInjured} /> Injuries/Conditions
					</strong>
					<Form.Control 
						as="textarea"
						defaultValue={client?.injuries}
						onChange={e=>{
							debouncedUpdate(clientId,{injuries:e.target.value})
						}}
					/>
				</div>
			)
		},
		{
			name:'Tags',
			icon:'faTag',
			component:<Tags clientId={clientId}/>
		},
		gymComponent,
		{
			name:'Disable/Delete',
			icon:'faTriangleExclamation',
			component:(
				<div>
					<strong>Account Status</strong>
					<Alert variant="warning" className="text-dark">
						<FontAwesomeIcon icon={faIcons.faCircleExclamation} className="mr-1"/>
						Disabling a client will prevent them from having access to their account. You can always re-activate them.
					</Alert>
					<div>
						<Form.Switch 
							onChange={ e => {
								update(
									clientId,
									{inactivate_account:Number(!e.target.checked)}
								)
							}}
							checked={!Boolean(client?.inactivate_account)}
							id="client-status-switch"
							label={
								<span className={Boolean(client?.inactivate_account)?"text-danger":"text-success"}>
									<FontAwesomeIcon 
										className="mr-1"
										icon={
											faIcons[
												Boolean(client?.inactivate_account)
												?'faUserSlash' 
												:'faUser'
											]
										}
									/>
									Client is {Boolean(client?.inactivate_account)?'Inactive' :'Active'}
								</span>
							}
						/>
					</div>
					<hr/>
					<strong>
						Downgrade to Prospect
					</strong>
					<div className="mb-2">
						<Button 
							disabled={downgrading}
							onClick={handleDowngradeToProspect}
							variant="outline-dark"
						>
							Downgrade to Prospect {downgrading&&<Spinner animation="border" size="sm"/>}
						</Button>
					</div>
					<strong>Delete Client</strong>
					<div>
						<small>If you do this by mistake please contact <a href="#TODO">support@fitsw.com</a>.</small>
					</div>
					<Button 
						disabled={downgrading}
						variant="outline-danger"
						onClick={()=>{
							remove(client?.user_id_number,()=>{
								dispatch(getChatRooms())
							})
						}}
					>
						Delete this client
					</Button>
				</div>
			)
		}
	]

	

	return (
		<div>
			<div  className={css.TabGrid}>
				{groups.filter(Boolean).map(
					({name,component,icon}) => (
						<Group key={name} name={name} icon={icon}>{component}</Group>
					)
				)}
			</div>
		</div>
	)
}

const Contracts = ({clientId})=>{
	const statusDispatch = useApiStatusDispatch()
	const urlParams = new URLSearchParams(window.location.search)
	const trainer = urlParams.get('trainer')
	const trainerParam = (
		Boolean(trainer)
		? `&trainer=${trainer}`
		: ''
	)
	const client = useUser(clientId)
	const {status,forms} = useClientCustomForms(clientId)

	const update = useUpdateClientProfileData()

	const formsSortComparer = (a, b) => a.form_title.localeCompare(b.form_title)
	const handleFormAssignChange = ( assigned, id)=> {
		if (assigned) {
			let payload = {
				action: "addFormToClient",
				client_id: clientId,
				form_id: id
			}
			statusDispatch(addFormToClient(payload), "form", "assign")
		} else {
			let payload = {
				action: "removeFormFromClient",
				client_id: clientId,
				form_id: id
			}
			statusDispatch(removeFormFromClient(payload), "form", "unassign")
		}
	}
	const reassignForm = (id)=>{
		statusDispatch(updateFormComplete({
			complete_status: "0",
			client_id: clientId,
			form_id: id,
			default_form: id== "0" ? "1" : "0"
		}),'form','edit')
	}

	const [contract,setContract] = useState(null)
	const [file,setFile] = useState(null)
	const {processUpload} = useS3DirectUpload()

	const handleChangeContract = async e => {
		const contract = e.target.files[0]
		if(!Boolean(contract)) return 
		const s3Res = await processUpload(contract)
		update(clientId,{contract:s3Res.payload.url})
	}

	const handleChangeFile = async e => {
		const file = e.target.files[0]
		if(!Boolean(file)) return 
		const s3Res = await processUpload(file)
		update(clientId,{par_q:s3Res.payload.url})
	}

	const groups = [
		{
			name:'Uploads',
			icon:'faFileArrowUp',
			component:(
				<div>
					<div>
						<strong>
							<FontAwesomeIcon icon={faIcons.faSignature} className="mr-1"/>
							Contract (optional)
						</strong>
						<Form.File 
							onChange={handleChangeContract}
							id="training-contract" 
							label="training contract" 
							custom
						/>
						{Boolean(client?.contract)&&
							<div>
								<a href={client?.contract} target="_blank" className="mr-1">
									View existing contract
								</a>
								<small>
									Uploading a new file will overwrite the existing Upload.
								</small>
							</div>
						}
					</div>
					<div>
						<strong>
							<FontAwesomeIcon icon={faIcons.faFile} className="mr-1"/>
							Upload Another File (optional)
						</strong>
						<Form.File 
							onChange={handleChangeFile}
							id="training-file" 
							label="new file" 
							custom
						/>
						{Boolean(client?.par_q)&&
							<div>
								<a href={client?.par_q} target="_blank" className="mr-1">
									View existing file
								</a>
								<small>
									Uploading a new file will overwrite the existing Upload.
								</small>
							</div>
						}
					</div>
				</div>
			)
		},
		{
			name:'Forms',
			icon:'faFileCircleLines',
			component:(
				<div>
					<Alert variant="info" className="my-2 text-dark">
						<FontAwesomeIcon icon={faIcons.faCircleInfo} className="mr-1"/>
						These are custom forms that you can create in the <Link to="/customForms">Forms List</Link>. Click on the form name below to edit/view client answers.
					</Alert>
					<div className={css.MiniGrid}>
						{forms.sort(formsSortComparer).map(
							({form_title,assigned,complete,form_id,date_completed},i)=>(
								<div key={form_id} className={css.Form}>
									<small className="d-flex justify-content-between align-items-start flex-wrap">
										{assigned&&
											<>
												<Link to={`/formEditor?formId=${form_id}&clientId=${clientId}${trainerParam}`}>
													<FontAwesomeIcon icon={faIcons.faArrowUpRightFromSquare} className="mr-1"/>
													{form_title}
												</Link>
											
												<Badge variant={complete==='1'?'success':'secondary'}>
													{complete==='1'?'complete':'incomplete'}
												</Badge>
											</>
										}
										{!assigned&&
											<span>{form_title}</span>
										}
									</small>
									{complete==='0'&&
										<Form.Switch
											onChange={e=>{
												handleFormAssignChange(
													e.target.checked,
													form_id
												)
											}}
											checked={assigned}
											id={`client-form-${i}`}
											label={
												assigned
												? <small className="text-success">
													<FontAwesomeIcon icon={faIcons.faFileCircleCheck}/> Assigned
												</small>
												: <small className="text-muted">
													<FontAwesomeIcon icon={faIcons.faFileCircleMinus}/> Not Assigned
												</small>
											}
										/>
									}
									{complete==='1'&&
										<>
											<small className="d-block">
												<span className="mr-1">
													Completed:
												</span>
												<br/>
												<LocaleDate 
													date={
														new Date(date_completed.split(' ').join('T'))
													}
												/>
											</small>
											<Button 
												onClick={reassignForm.bind(null,form_id)}
												className="text-success"
												variant="link" 
												size="sm"
											>
												<FontAwesomeIcon icon={faIcons.faRotateRight} className="mr-1"/>
												Re-assign form
											</Button>
										</>
									}
								</div>
							)
						)}
					</div>
				</div>
			)
		},
	]

	return (
		<div>
			<div>
				{groups.map(
					({name,component,icon}) => (
						<div key={name} className="mb-4">
							<Group name={name} icon={icon}>{component}</Group>
						</div>
					)
				)}
			</div>
		</div>
	)
}

const Clubready = ({clientId})=>{
	const statusPost = useApiStatusEnvAwarePost()
	const statusDispatch = useApiStatusDispatch()
	const dispatch = useDispatch()
	const client = useUser(clientId)
	const [clubReadyId, setClubReadyId] = useState("");
	const [clubReadyBarcode, setClubReadyBarcode] = useState("");
	const [showClubReady, setShowClubReady] = useState(false);
	const [isCreateClubReadyLoading, setIsCreateClubReadyLoading] = useState(false);
	const [clubReadyCreateId, setClubReadyCreateId] = useState("");
	const [clubReadyCreateBarcode, setClubReadyCreateBarcode] = useState("");
	const [isLoading,setIsLoading] = useState(false)

	useEffect(() => {
		if (!clientId) return
		setIsLoading(true)
		dispatch(getClubReadyIdBarcode(clientId)).then(res => {
			let data = res.payload.data;
			if (data) {
				setClubReadyId(data.clubready_id ? data.clubready_id : "");
				setClubReadyBarcode(data.clubready_barcode ? data.clubready_barcode : "");
			}
			setIsLoading(false)
		})
	},[])

	//general helper for immediatly saving client data
	const saveClientData = (payload)=>{
		statusPost('api/users/',{
			action:'updateClientProfileData',
			client_id:clientId,
			...payload
		},'client','edit')
	}

	const handleChangeClubreadyId = e => {
		const clubready_id = e.target.value
		if(clubready_id===clubReadyId) return
		setClubReadyId(clubready_id)
		saveClientData({
			clubready_barcode:clubReadyBarcode,
			clubready_id
		})
	}

	const handleChangeClubreadyBarcode = e => {
		const clubready_barcode = e.target.value
		if(clubready_barcode===clubReadyBarcode) return
		setClubReadyBarcode(clubready_barcode)
		saveClientData({
			clubready_id:clubReadyId,
			clubready_barcode
		})
	}

	function handleClubReadySave() {
		setIsCreateClubReadyLoading(true);
		statusDispatch(createClubReady({ id: clubReadyCreateId, barcode: clubReadyCreateBarcode, client_id: clientId }), "clubReady Account", "add")
			.then(res => {
				dispatch(getClubReadyIdBarcode(clientId)).then(res => {
					let data = res.payload.data;
					if (data) {
						setClubReadyId(data.clubready_id);
						setClubReadyBarcode(data.clubready_barcode);
					}
				})
				setShowClubReady(false)
				setIsCreateClubReadyLoading(false)
			});

	}

	return (
		<div>
			<div>
				<strong className="text-center mt-2">ClubReady</strong>
				{!isLoading&&
					<div>
						{(clubReadyId || clubReadyBarcode) ?
							<div className="">
								<div className="">
									<Form.Label className="mt-2"><strong><label>ClubReady Id </label></strong></Form.Label>
									<Form.Control onBlur={handleChangeClubreadyId} defaultValue={clubReadyId} />
								</div>
								<div className="">
									<Form.Label className="mt-2"> <strong><label>ClubReady Barcode </label></strong></Form.Label>
									<Form.Control onBlur={handleChangeClubreadyBarcode} defaultValue={clubReadyBarcode} />
								</div>
							</div> :
							<div className="text-center">
								<Button className="mt-3" onClick={() => { setShowClubReady(true) }} variant="outline-primary"> Connect ClubReady Account</Button>
							</div>
						}
					</div>
				}
				{isLoading&&
					<div className="text-center p-3">
						<Spinner animation="border"/>
					</div>
				}
			</div>
			<Modal show={showClubReady} onHide={() => setShowClubReady(false)}>
				<Modal.Header closeButton>
					<strong>Connect ClubReady Account </strong>
				</Modal.Header>
				<Modal.Body>
					<div className="">
						<div className="">
							<Form.Label className="mt-2"><strong><label>ClubReady Id </label></strong></Form.Label>
							<Form.Control onChange={e => setClubReadyCreateId(e.target.value)} value={clubReadyCreateId} />
						</div>
						<div className="">
							<Form.Label className="mt-2"> <strong><label>ClubReady Barcode </label></strong></Form.Label>
							<Form.Control onChange={e => setClubReadyCreateBarcode(e.target.value)} value={clubReadyCreateBarcode} />
						</div>
					</div>

				</Modal.Body>
				<Modal.Footer>
					<div>
						<Button
							variant="outline-danger"
							onClick={() => setShowClubReady(false)}
						>Close</Button>
						<Button
							disabled={isCreateClubReadyLoading}
							className="ml-2"
							variant="outline-primary"
							onClick={handleClubReadySave}
						>{isCreateClubReadyLoading ? <Spinner animation="border" role="status" size="sm" variant="primary" /> : "Save"}</Button>
					</div>
				</Modal.Footer>

			</Modal>
		</div>
	)
}

const Note = props => {
	const dispatch = useDispatch()
	const { note, dateCreated, note_id, client_id } = props.note
	const [mode, setMode] = useState('read')
	const [editNoteBody, setEditNoteBody] = useState(note)
	const [editNoteDate, setEditNoteDate] = useState(new Date());



	useEffect(() => {
		setEditNoteBody(note);
		setEditNoteDate(new Date(dateCreated?.split(' ').join('T')))
	}, [note])

	const cancelEdit = () => {
		setMode('read')
	}
	const saveHandler = () => {
		setMode('read')
		dispatch(updateNote({
			dateCreated: dateToAPIStandard(editNoteDate),
			note: editNoteBody,
			note_id,
		}))
	}
	const deleteHandler = () => {
		if (!window.confirm('Are you sure?')) return
		dispatch(deleteNote({
			client_id,
			note_id
		}))
	}

	return (
		<div className="border p-2 mb-2 rounded" style={{fontSize:'12px'}}>
			{
				mode === 'read' ?
					note :
					<div>
						<span> Select Date: </span> 
						<DatePicker
							className="mb-2 ml-2"
							selected={editNoteDate}
							onChange={(date) => { setEditNoteDate(date) }}
							dateFormat="EEE, MMM d, yyyy"
						/>
						<Form.Control as="textarea" value={editNoteBody} onChange={e => setEditNoteBody(e.target.value)} style={{minHeight:'300px'}} />
					</div>
			}
			<hr className="my-1" />
			<div className="d-flex justify-content-between">
				{
					mode === 'read' ?
						<div>
							<small style={{ cursor: "pointer" }} onClick={() => setMode('edit')} className="mr-2 text-info">edit</small>
							<small style={{ cursor: "pointer" }} onClick={deleteHandler} className="text-danger">delete</small>
						</div> :
						<div>
							<small style={{ cursor: "pointer" }} onClick={cancelEdit} className="mr-2 text-danger">cancel</small>
							<small style={{ cursor: "pointer" }} onClick={saveHandler} className="text-success">save</small>
						</div>
				}
				<small>
					{(new Date(dateCreated.replace(/-/g, "/")).toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric'}))}
				</small>
			</div>
		</div>
	)
}

const Notes = ({ clientId }) => {
	const dispatch = useDispatch()
	const notes = useSelector(selectAllNotes)
	const recentNote = useSelector(state => selectAllNotes(state)[0])
	const [addingNote, setAddingNote] = useState(false)
	const [showNotesModal, setShowNotesModal] = useState(false)
	const [offset, setOffset] = useState(0)

	//body of new note 
	const [newNoteBody, setNewNoteBody] = useState('')
	//date of new note
	const [addNoteDate, setAddNoteDate] = useState(new Date());

	const notesStatus = useSelector((state) => state.clientNotes.status);
	const saveHandler = () => {
		dispatch(saveNote({
			client_id: clientId,
			dateCreated: dateToAPIStandard(addNoteDate),
			newNote:newNoteBody
		}))
		setAddingNote(false)
	}

	const recentHandler = () => {
		let newOffSet = offset + 10
		setOffset(newOffSet)
		dispatch(getRecentNotes({
			client_id: clientId,
			offset,
			limit: 10
		}))
	}

	useEffect(() => {
		dispatch(initNotes({
			client_id: clientId,
			offset: 0,
			limit: 10
		}))
	}, [clientId])

	if (!clientId) return null

	const handleShowNotesModal = () => {
		setShowNotesModal(true)
		setOffset(0)
	}

	const handleHideNotesModal = () => {
		setShowNotesModal(false)
		dispatch(initNotes({
			client_id: clientId,
			offset: 0,
			limit: 10
		}))
	}

	return (
		<div>

			<div className="d-flex align-items-center justify-content-between flex-wrap">
				<small style={{fontSize:"14px"}}>
					<i  className="fa fa-info-circle mr-1 my-1"></i>  
					Notes are hidden from clients
				</small>
				<Button
					variant="outline-success"
					onClick={() => {
						setAddNoteDate(new Date())
						setAddingNote(!addingNote)}
					}
					size="sm"
				>
					<FontAwesomeIcon icon={faIcons.faPlus} className="mr-1"/>
					Add Note
				</Button>
			</div>
			<hr/>
			{addingNote &&
				<div>
					Select Date:
					<DatePicker
						className="mb-2 ml-2"
						selected={addNoteDate}
						onChange={(date) => { setAddNoteDate(date) }}
						dateFormat="EEE, MMM d, yyyy"
					/>
					<Form.Control
						value={newNoteBody}
						onChange={e => setNewNoteBody(e.target.value)}
						as="textarea" 
						style={{minHeight:'300px'}}
					/>
					<div className="my-1">
						<Button
							size="sm"
							onClick={() => setAddingNote(!addingNote)}
							variant="outline-danger">
							Cancel
						</Button>
						<Button
							onClick={saveHandler}
							variant="outline-success"
							size="sm"
							className="ml-1">
							Save
						</Button>
					</div>
				</div>
			}
			<span>Most Recent:</span>
			<div>
				{
					notesStatus === "loading" ? <Spinner size="sm" animation="border" role="status" variant="primary"/> : 
					recentNote ?
						<Note note={recentNote}/>
						:
						'No notes'
				}
			</div>
			<div>
				{
					recentNote ?
						<Button
							onClick={handleShowNotesModal}
							variant="outline-dark"
							block
							className="mt-2">
							View all notes
						</Button>
						:
						null
				}
			</div>
			<Modal show={showNotesModal} onHide={handleHideNotesModal} size="xl">
				<Modal.Header closeButton>
					<Modal.Title>Notes</Modal.Title>
				</Modal.Header>
				{notesStatus === 'loading' ?
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Spinner animation="border" role="status" variant="primary">
						</Spinner>
					</div>
					:
					<Modal.Body>
						{notes.map(note => (
							<Note key={note.id || note.note_id} note={note} />
						))}
					</Modal.Body>
				}
				<Modal.Footer>
					{notes.length < 10 ? null :
						<>
							<Button onClick={recentHandler} variant="primary">Load more</Button>
						</>
					}
				</Modal.Footer>
			</Modal>
		</div>
	)
}

const Sessions = ({ clientId })=>{
	const client = useUser(clientId)
	const {clientAggregates} = useSessions()
	const data = clientAggregates.find(
		agg => parseInt(agg.client?.id) === parseInt(clientId)
	)
	const [showAddSessionModal,setShowAddSessionModal] = useState()

	const groups = [
		{
			name:'Sessions',
			icon:'faPersonArrows',
			component:(
				<div>
					<Alert variant="info" className="text-dark">
						<small>
							<FontAwesomeIcon icon={faIcons.faCircleInfo} className="mr-1"/>
							Use the <FontAwesomeIcon icon={faIcons.faCaretUp}/> and <FontAwesomeIcon icon={faIcons.faCaretDown}/> arrows to update the number of sessions a client has used or the number they have credited to them. Click "more info" to see when sessions were credited or when they where completed. Click "Add Sessions to Client" to add multiple sessions at once.
						</small>
					</Alert>
					{Boolean(data)&&
						<div>
							<div className="text-right">
								<small>Complete / Total</small>
							</div>
							<ClientSessionsRow data={data} showName={false}/>
						</div>
					}
					<div className="text-right mt-2">
						<OverlayTrigger overlay={
							<Tooltip>Manually Credit Sessions to a Client</Tooltip>
						}>
							<Button  
								onClick={()=>{ setShowAddSessionModal(true) }}
								className="ml-2"
								variant="outline-primary ml-auto"
								style={{flex:'0 0 auto'}}
								size="sm"
							>
								Add Sessions to Client
							</Button>
						</OverlayTrigger>
						<AddSessionModal
							defaultClientId={clientId}
							show={showAddSessionModal}
							showPaymentOptions={false}
							onHide={()=>{setShowAddSessionModal(false)}}
						/>
					</div>
				</div>
			)
		},{
			name:'Notes',
			icon:'faNoteSticky',
			component:<Notes clientId={clientId}/>
		}
	]

	return (
		<div>
			{groups.map(
				({name,component,icon}) => (
					<div key={name} className="mb-4">
						<Group name={name} icon={icon}>{component}</Group>
					</div>
				)
			)}
		</div>
	)
}

const AssignedProgram = ({ assignedProgram }) => {
	const dispatch = useDispatch()
	const [showDeleteModal, setShowDeleteModal] = useState(false)

	return (
		<>
			<div className="border rounded p-1 px-2 mb-2">
				<div>
					{assignedProgram.name}
				</div>
				<hr className="my-1"/>
				<div className="d-flex justify-content-between align-items-center flex-wrap">
					<small className="text-primary">
						<FontAwesomeIcon 
							icon={faIcons.faCalendar} 
							className="mr-1"
						/>
						{assignedProgram.start_date} to {assignedProgram.end_date}
					</small>
					<Button
						onClick={() => { setShowDeleteModal(true) }}
						className="text-danger ml-auto"
						variant="link"
						size="sm"
					>
						delete
					</Button>
				</div>
			</div>
			<DeleteProgramModal
				onDelete={(future_only) => {
					setShowDeleteModal(false)
					dispatch(deleteProgramAssignment({
						client_id: assignedProgram.assigned_user_id_number,
						assignment_id: assignedProgram.id,
						future_only
					}))
				}}
				setShow={setShowDeleteModal}
				show={showDeleteModal}
				deleteType="single"
			/>
		</>
	)
}

/**
 * Capitalizes and pluralizes (if needed)
 **/
const formatDataNames = name => {
	if (['workout', 'task'].includes(name)) name = name + 's'
	name = capitalize(name)
	return name
}

const ComplianceInfo = ({ compliance, clientId }) => {
	const client = useUser(clientId)
	let dispatch = useDispatch();
	const trainerParam = useSelector(selectTrainerParam)
	const isMAXUser = useSelector(state => Boolean(state.users?.current_user?.isMAXUser))
	if(!compliance) return null
	return (
		<div className={css.Bars}>
			{['workout', 'task', 'nutrition'].map(key => {
				//grab data object from client props object

				const data = compliance[key]

				//get data and make sure it is valid
				let complete = parseInt(data.complete)
				if (isNaN(complete)) complete = 0

				let open = parseInt(data.open)
				if (isNaN(open)) open = 0

				let notMet = parseInt(data.notMet)
				if (isNaN(notMet)) notMet = 0


				const total = complete + open + notMet
				//to avoid division by zero ensure that (total >= 1)
				const safeTotal = total || 1
				//calculate the percentages
				const completePercent = (complete / safeTotal * 100)
				const openPercent = (open / safeTotal * 100)
				const notMetPercent = (notMet / safeTotal * 100)


				const generateLabel =(percent, count) => {
					return (
						<div className={css.ComplianceContainer}>
							<div className="mx-1">{percent}% </div>
							<div className={css.ComplianceCountLarge}>{count}</div>
							<div className={css.ComplianceCountMed}>({count})</div>
						</div>
					)
				}
				//location to send user to
				const location =
					`/eventsView?display=all&selector=all&filter=client&client=${clientId}&${trainerParam}`

				//form object to map to JSX
				const barData = [
					{
						percent: completePercent,
						count: complete,
						variant: 'success',
					}, {
						percent: notMetPercent,
						count: notMet,
						variant: 'danger',
					}, {
						percent: openPercent,
						count: open,
						variant: 'secondary',
					},
				]
				if (
					key === 'nutrition' &&
					compliance.simplified_nutrition.assigned &&
					total === 0
				) return null
				return (
					<div key={key} className={css.EventData}>
						<strong className={css.EventName}>
							<a href={location} className="d-block" target="_blank">
								<FontAwesomeIcon icon={faIcons.faArrowUpRightFromSquare} className="mr-1"/>
								{formatDataNames(key)}
							</a>
						</strong>
						<ProgressBar
							onClick={() => {
								const expandData = {
									clientName: client.user_name,
									title: capitalize(key),
									linkText: formatDataNames(key),
									complete,
									notMet,
									open,
									location
								}
							}}
							className={css.ProgressBar}
							key={key}>
							{barData.map((data, i) => (
								<ProgressBar
									variant={data.variant}
									now={data.percent}
									label={ generateLabel(
										(Math.round(data.percent) !== data.percent ?
											data.percent.toFixed(0) :
											data.percent),
											data.count

									)
									}
									key={i} />
							))}
						</ProgressBar>
					</div>
				)//end progress js to return
			})}
			{Boolean(compliance.simplified_nutrition.assigned)&&
				<div className={css.EventData}>
					<strong className={css.EventName}>
						<a
							href={`/eventsView?display=all&selector=all&filter=client&client=${clientId}&${trainerParam}`}
							target="_blank"
						>
								<FontAwesomeIcon icon={faIcons.faArrowUpRightFromSquare} className="mr-1"/>
								{isMAXUser ? `MAX Nutrition (${compliance.simplified_nutrition.days})` : "Simplified Nutrition"}
						</a>
					</strong>
					<ProgressBar
						onClick={() => {
							const complete = compliance.simplified_nutrition.completed
							const assigned = compliance.simplified_nutrition.assigned
							const notMet = assigned - complete
							const expandData = {
								clientName: client.user_name,
								title: isMAXUser ? `MAX Nutrition` : "Simplified Nutrition",
								linkText: "Nutrition",
								complete,
								notMet,
								open: 0,
								location: `/eventsView?display=all&selector=Nutrition&filter=client&client=${clientId}&${trainerParam}`
							}
						}}
						className={css.ProgressBar}>
						{[
							{
								percent: (
									compliance.simplified_nutrition.completed /
									compliance.simplified_nutrition.assigned
								) * 100,
								count: Math.round(compliance.simplified_nutrition.completed * 100) / 100,
								variant: 'success',
							}, {
								percent: (
									(
										compliance.simplified_nutrition.assigned -
										compliance.simplified_nutrition.completed
									) /
									compliance.simplified_nutrition.assigned
								) * 100,
								count: Math.round((
									compliance.simplified_nutrition.assigned -
									compliance.simplified_nutrition.completed
								) * 100) / 100,
								variant: 'danger',
							}
						].map((data, i) => (
							<ProgressBar
								variant={data.variant}
								now={data.percent}
								label={
									`${
									//only truncate to zero decimals if
									//the percentage is a non-int
									Math.round(data.percent) !== data.percent ?
										data.percent.toFixed(0) :
										data.percent
									}%`
								}
								key={i} />
						))}
					</ProgressBar>
				</div>
			}
		</div>
	)
}

const DailyMacros = ({ clientId }) => {
	const client = useUser(clientId)
	let dispatch = useDispatch();
	console.log(client)
	const macros = [
		'calories',
		'carbs',
		'fat',
		'fiber',
		'protein',
		'sodium',
		'water',
	]

	const handleUpdate = update => {
		envAwarePost('api/users/',{
			action:'updateClientBio',
			client_id:clientId,
			update
		}).then(res=>{
			console.log(res)
		})
	}

	const debouncedUpdate = useDebounceCallback(handleUpdate,500)

	return (
		<div>
			<p>
				<i className="fa fa-info-circle"/> The daily recommended macros for this client. These will autofill into nutrition plans.
			</p>
			{macros.map(macro=>(
				<div key={macro}>
					<small>{capitalize(macro)}</small>
					<br/>
					<Form.Control 
						defaultValue={client&&client[`daily_${macro}`]}
						onChange={(e)=>{
							const key = `daily_${macro}`
							debouncedUpdate(
								{[key]:e.target.value}
							)
						}}
					/>
				</div>
			))}
		</div>
	)
}

const Fitness = ({clientId})=>{
	const client = useUser(clientId)
	const [showProgramsModal, setShowProgramsModal] = useState(false)
	const groups = [
		{
			name:'Compliance',
			icon:'faBarsProgress',
			component:<ComplianceInfo compliance={client?.compliance} clientId={clientId} />
		},
		{
			name:'Daily Macros',
			icon:'faFood',
			component:<DailyMacros clientId={clientId}/>
		},
		{
			name:'Programs',
			icon:'faCalendarWeek',
			component:(
				<div>
					<Alert variant="info" className="text-dark">
						<small>
							<FontAwesomeIcon 
								icon={faIcons.faCircleInfo} 
								className="mr-1"
							/>
							All active programs assigned to this client. Programs assigned to this client that have already ended are not shown.
						</small>
					</Alert>
					<div className="mb-1">
						<Link 
							variant="outline-success" 
							to="/programs"
							size="sm"
						>
							Go to Program Library
						</Link>
					</div>
					<div className={css.MiniGrid}>
						{client?.assigned_programs.length > 0 ?
							//only show 5 of the assigned programs
							<>
								{client?.assigned_programs.map(
									(assignedProgram,i) => <AssignedProgram key={i} assignedProgram={assignedProgram} />
								)}
							</>
							:
							<div className="text-center">This client has no assigned programs</div>
						}
					</div>
				</div>
			)
		}
	]
	return (
		<div>
			{groups.map(
				({name,component,icon}) => (
					<div key={name} className="mb-4">
						<Group name={name} icon={icon}>{component}</Group>
					</div>
				)
			)}
		</div>
	)
}

const ThirdParty = ({clientId})=>{
	const isMAXUser = useSelector(state => Boolean(state.users.current_user.isMAXUser))
	const [isEmailingFitbitLink,setIsEmailingFitbitLink] = useState(false)
	const handleEmailFitbitLink = ()=>{
		setIsEmailingFitbitLink(true)
		envAwarePost('api/third-party/',{
			action:'emailFitbitAuthorizationLink',
			client_id:clientId
		}).then(res=>{
			setIsEmailingFitbitLink(false)
		})
	}
	return (
		<div>
			{isMAXUser&&
				<>
					<Clubready clientId={clientId}/>
					<hr className="my-2"/>
				</>
			}
			<strong>Fitbit</strong>
			<Button 
				onClick={handleEmailFitbitLink}
				disabled={isEmailingFitbitLink}
				variant="outline-info" 
				block
			>
				Email Client to Connect Fitbit to FitSW {isEmailingFitbitLink&&<Spinner animation="border" size="sm"/>}
			</Button>
		</div>
	)
}

const Misc = ({clientId})=>{
	const groups = [
		{
			name:'Third Party Integrations',
			icon:'faNetworkWired',
			component:<ThirdParty clientId={clientId}/>
		}
	]
	return (
		<div>
			{groups.map(
				({name,component,icon}) => (
					<Group key={name} name={name} icon={icon}>{component}</Group>
				)
			)}
		</div>
	)
}

const makePaymentMethodDefault = (payment_method_id,client_id) => envAwarePost(
	'api/user/api/',
	{action:'clientMakePaymentMethodDefault',payment_method_id,client_id}
)

const BillingUpdateForm = ({clientId,onSuccess})=>{
	const stripe = useStripe()
	const elements = useElements()
	const dispatch = useDispatch()
	const [status,setStatus] = useState('idle')

	const confirmSetup = () => (
		stripe.confirmSetup({
			elements,
			confirmParams: {
				return_url: 'https://www.fitsw.com',
			},
			redirect:'if_required'
		})
	)
	const handleUpdate = async (event)=>{
		setStatus('pending')
		// Block native form submission.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		confirmSetup().then(res=>{
			if (res.error) throw new Error(res.error.message)
			if (res.setupIntent.status !== 'succeeded') {
				throw new Error("Something went wrong. Please, try again")
			}
			return makePaymentMethodDefault(res.setupIntent.payment_method,clientId)
		}).then( res => {
			setStatus('idle')
			onSuccess()
		}).catch( err => {
			setStatus('idle')
			window.alert(err)
		})
	}
	return (
		<div>
			<PaymentElement /> 
			<Button 
				disabled={status==='pending'}
				variant="outline-primary" 
				onClick={handleUpdate}
				className="mt-2" 
				block
			>
				<span className="mr-1">Update</span>
				{status==='pending'&&<Spinner animation="border" size="sm" />}
			</Button>
		</div>
	)
}

const Billing = ({clientId})=>{
	const dispatch = useDispatch()

	const subscriptions = useActiveSubscriptions().subscriptions
		.filter(({client_id})=>parseInt(clientId)===parseInt(client_id))
	console.log(subscriptions)

	//get client billing info
	const [status,setStatus] = useState('pending')
	const [paymentMethod,setPaymentMethod] = useState(false)

	const getClientBillingInfo = ()=>{
		setStatus('pending')
		envAwarePost('api/billing/',{
			action:'getClientBillingInfo',
			client_id:clientId
		}).then(res=>{
			setPaymentMethod(res.data.payment_method)
			setStatus('idle')
		})
	}

	useEffect(()=>{
		getClientBillingInfo()
	},[])

	const [showUpdateModal,setShowUpdateModal] = useState(false)
	const handleUpdateBilling = ()=>{
		setShowUpdateModal(true)
	}

	const user = useCurrentUser()

	const stripePromise = useStripeAccount(
		user.stripe_account.stripe_user_id
	)

	const getSetupIntent = () => envAwarePost(
		'api/user/api/',
		{action:'getClientSetupIntent',client_id:clientId}
	)

	const [clientSecret,setClientSecret] = useState(null)
	
	useEffect( async ()=>{
		const res = await getSetupIntent()
		setClientSecret(res.data.setup_intent.client_secret)
	},[])

	if ( status === 'pending' ) return (
		<Spinner animation="border" />
	)

	return (
		<div>
			<div className="mb-4">
				<Group name="Payment Method" icon="faCreditCard">
					{
						paymentMethod.payment_method_exists 
						?
						<div>
							<strong>Current {paymentMethod.default.method_type==='card'?'card':'bank account'} on file</strong>: {capitalize(paymentMethod.default.brand)} ({paymentMethod.default.last4})
						</div>
						:
						<div>
							No card on file
						</div>
					}
					<Button 
						onClick={handleUpdateBilling}
						variant="outline-primary"
						size="sm"
					>
						Update Billing Info
					</Button>
				</Group>
			</div>
			<Group name="Active Subscriptions" icon="faClipboard">
				{subscriptions.length===0&&
					'No active subscriptions'
				}
				{subscriptions.length>0&&
					<Table>
						<thead className="bg-dark text-white">
							<tr>
								<td>Subscription</td>
								<td>Client</td>
								<td>Amount</td>
								<td>Billing Cycle</td>
								<td>Toggle</td>
								<td>Cancel</td>
							</tr>
						</thead>
						<tbody>
							{subscriptions.map(subscription=>(
								<ActiveSubscription subscription={subscription}/>
							))}
						</tbody>
					</Table>
				}
			</Group>
			<Modal 
				show={showUpdateModal} 
				onHide={setShowUpdateModal.bind(null,false)}
			>
				<Modal.Header closeButton>
					Update Card On File
				</Modal.Header>
				<Modal.Body>
					{(Boolean(stripePromise)&&Boolean(clientSecret))&&
						<Elements stripe={stripePromise} options={{clientSecret}}>
							<ElementsConsumer>
								{() => (
									<BillingUpdateForm 
										onSuccess={()=>{
											setShowUpdateModal(false)
											getClientBillingInfo()
										}}
										clientId={clientId}
									/>
								)}
							</ElementsConsumer>
						</Elements>
					}
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default function ClientProfile ({location}) {
	const params = new URLSearchParams(location.search)
	const clientId = params.get('clientId')
	const tab = params.get('tab')

	const [currentKey,setCurrentKey] = useState(
		Boolean(tab)
		? tab
		: 'clientInfo'
	)

	const keyComponentMap = {
		clientInfo:<ClientInfo clientId={clientId}/>,
		contracts:<Contracts clientId={clientId}/>,
		session_notes:<Sessions clientId={clientId}/>,
		fitness:<Fitness clientId={clientId}/>,
		billing:<Billing clientId={clientId}/>,
		misc:<Misc clientId={clientId}/>,
	}

	const isMAXUser = useSelector(state => Boolean(state.users.current_user.isMAXUser))
	const user = useCurrentUser()
	console.log(user)
	const isOwner = (
		(parseInt(user.gym_id)!==0&&user.account_type==='gym')
		||
		(parseInt(user.gym_id)===0&&user.account_type==='trainer')
	)
	
	const tabs = [
		{
			key:'clientInfo',
			title:(
				isMAXUser
				? 'Member Info'
				: 'Client Info'
			),
			icon:'faPerson',
		},
		{
			key:'contracts',
			icon:'faFileContract',
			title:'Contracts & Forms',
		},
		{
			key:'session_notes',
			icon:'faClipboard',
			title:'Sessions & Notes',
		},
		{
			key:'fitness',
			icon:'faHeartPulse',
			title:'Health & Programs',
		},
		{
			key:'billing',
			icon:'faCreditCard',
			title:'Billing & Subscriptions',
			hide:(
				!isOwner && !user.permissions.manage_billing
			)
		},
		{
			key:'misc',
			icon:'faShapes',
			title:'Misc.',
		},
	]
	return (
		<div 
			className="pt-2 px-2 px-md-3" 
			style={{
				background:'#f3f3f3',
				height:'100%',
				overflow:'auto',
				paddingBottom:'200px'
			}}
		>
			<div className="d-none d-md-block">
				{tabs
					.filter(({hide})=>!hide)
					.map(
						({key,title,icon})=>(
							<Button 
								variant={
									currentKey === key
									? 'primary'
									: "outline-primary" 
								}
								className="mr-1 mb-1"
								key={key} 
								onClick={setCurrentKey.bind(null,key)}
								size="sm"
							>
								<FontAwesomeIcon icon={faIcons[icon]} className="mr-1"/>
								{title}
							</Button>
						)
					)
				}
			</div>
			<div className="d-md-none">
				<strong>Choose Section of Client Info:</strong>
				<Form.Control
					value={currentKey}
					onChange={e=>{
						setCurrentKey(e.target.value)
					}}
					as="select"
				>
					{tabs.map(
						({key,title,icon})=>(
							<option value={key}>
								{title}
							</option>
						)
					)}
				</Form.Control>
			</div>
			<div className="pt-4">
				{keyComponentMap[currentKey]}
			</div>
			<Alert variant="info" className="mt-2 mb-4 text-dark">
				<FontAwesomeIcon icon={faIcons.faCloudArrowUp}/> Information is automatically saved
			</Alert>
		</div>
	)
}